/**
 * Cart Restriction: Merch Drops Produkte können nur separat bestellt werden.
 *
 * Interception-Schichten:
 * 1. XMLHttpRequest prototype patching (fängt ALLE XHR ab, auch gebundeltes jQuery)
 * 2. fetch() override (moderne API-Calls)
 * 3. Form submit capture listener (direkte Form-Submits)
 */
(function () {
  'use strict';

  var config = window.MerchDropRestriction;
  if (!config || !config.variantIds) return;

  var variantSet = {};
  for (var i = 0; i < config.variantIds.length; i++) {
    variantSet[config.variantIds[i]] = true;
  }

  function isMerchDrop(variantId) {
    if (variantSet[parseInt(variantId, 10)] === true) return true;
    if (config.currentProductIsMerchDrop) {
      var formIdInput = document.querySelector('[data-product-form] [name="id"], form[action*="/cart/add"] [name="id"]');
      if (formIdInput && String(formIdInput.value) === String(variantId)) return true;
    }
    return false;
  }

  function shouldBlock(variantId) {
    var adding = isMerchDrop(variantId);
    if (adding && config.cartHasOther) return 'merch_blocked';
    if (!adding && config.cartHasMerchDrop) return 'other_blocked';
    return false;
  }

  function getErrorMessage(reason) {
    if (reason === 'merch_blocked') return config.errorMerchBlocked;
    if (reason === 'other_blocked') return config.errorOtherBlocked;
    return '';
  }

  function showInlineError(message) {
    removeInlineError();

    var anchor = document.querySelector('.product-form--atc')
      || document.querySelector('[data-product-form]')
      || document.querySelector('form[action*="/cart/add"]');

    if (!anchor) return;

    var el = document.createElement('div');
    el.className = 'cart-restriction-error';
    el.setAttribute('role', 'alert');
    el.textContent = message;

    anchor.parentNode.insertBefore(el, anchor.nextSibling);

    setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, 8000);
  }

  function removeInlineError() {
    var existing = document.querySelectorAll('.cart-restriction-error');
    for (var i = 0; i < existing.length; i++) {
      existing[i].parentNode.removeChild(existing[i]);
    }
  }

  function extractVariantId(data) {
    if (!data) return null;

    if (typeof data === 'string') {
      try {
        var json = JSON.parse(data);
        if (json && json.id) return json.id;
      } catch (e) {}

      var params = new URLSearchParams(data);
      var id = params.get('id');
      if (id) return id;
    }

    if (typeof FormData !== 'undefined' && data instanceof FormData) {
      return data.get('id');
    }

    if (typeof data === 'object' && data !== null) {
      if (data.id) return data.id;
      if (Array.isArray(data)) {
        for (var i = 0; i < data.length; i++) {
          if (data[i] && data[i].name === 'id') return data[i].value;
        }
      }
    }

    return null;
  }

  function updateStateAfterAdd(variantId) {
    if (isMerchDrop(variantId)) {
      config.cartHasMerchDrop = true;
    } else {
      config.cartHasOther = true;
    }
  }

  function syncCartState() {
    var cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url)
      ? window.Theme.routes.cart_url
      : '/cart';

    fetch(cartUrl + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        config.cartHasMerchDrop = false;
        config.cartHasOther = false;
        if (cart.items) {
          for (var i = 0; i < cart.items.length; i++) {
            if (isMerchDrop(cart.items[i].variant_id)) {
              config.cartHasMerchDrop = true;
            } else {
              config.cartHasOther = true;
            }
          }
        }
      })
      .catch(function () {});
  }

  // --- Schicht 1: XMLHttpRequest Prototype Patching ---
  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._crMethod = method;
    this._crUrl = url;
    return origXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (data) {
    if (
      this._crMethod &&
      this._crMethod.toUpperCase() === 'POST' &&
      this._crUrl &&
      this._crUrl.indexOf('/cart/add') !== -1
    ) {
      var variantId = extractVariantId(data);
      if (variantId) {
        var reason = shouldBlock(variantId);
        if (reason) {
          showInlineError(getErrorMessage(reason));
          this.abort();
          return;
        }
        var vid = variantId;
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            updateStateAfterAdd(vid);
          }
        });
      }
    }

    return origXHRSend.apply(this, arguments);
  };

  // --- Schicht 2: fetch() Override ---
  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var options = arguments[1] || {};

    var isCartAdd = false;
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      isCartAdd = (options.method && options.method.toUpperCase() === 'POST');
    }
    if (typeof url === 'object' && url instanceof Request) {
      isCartAdd = url.url.indexOf('/cart/add') !== -1 && url.method === 'POST';
    }

    if (isCartAdd) {
      var variantId = extractVariantId(options.body);
      if (variantId) {
        var reason = shouldBlock(variantId);
        if (reason) {
          showInlineError(getErrorMessage(reason));
          return Promise.reject(new Error('cart_restriction_blocked'));
        }
        var vid = variantId;
        return originalFetch.apply(this, arguments).then(function (response) {
          if (response.ok) updateStateAfterAdd(vid);
          return response;
        });
      }
    }

    return originalFetch.apply(this, arguments);
  };

  // --- Schicht 3: Form Submit Capture ---
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action) return;
    if (form.action.indexOf('/cart/add') === -1) return;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;

    var reason = shouldBlock(idInput.value);
    if (reason) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showInlineError(getErrorMessage(reason));
    }
  }, true);

  // --- State-Sync bei Cart-Änderungen (Entfernen von Artikeln) ---
  document.addEventListener('cartcount:update', syncCartState);

  // Fallback: periodisch bei Seitenwechsel
  if (document.addEventListener) {
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) syncCartState();
    });
  }
})();
